/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  PaginatedTransactionHistoryList,
  PaymentAvailableAmountRetrieve200,
  PaymentMethod,
  PaymentMethodCreate,
  PaymentTransactionHistoryListParams,
  RedemptionHistory,
  Transaction,
  TransactionCreate,
} from '../models'

import paymentAvailableAmountRetrieveMutator from '../../client'
import paymentMethodCreateCreateMutator from '../../client'
import paymentMethodListListMutator from '../../client'
import paymentRecentRedemptionsListMutator from '../../client'
import paymentTransactionCreateCreateMutator from '../../client'
import paymentTransactionHistoryListMutator from '../../client'
import paymentTransactionListListMutator from '../../client'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P]
    }
  : DistributeReadOnlyOverUnions<T>

/**
 * This API view that calculates the available amount for each currency by
summing up the user's report profits and subtracting the sum of processed
transaction amounts.

The view performs the following steps:
1. Retrieves all the user's report profits grouped by currency and calculates the sum for each currency.
2. Retrieves the user's transactions that are either processed or requested (excluding denied transactions),
   grouped by currency, and calculates the sum for each currency.
3. Computes the available amount for each currency
   by subtracting the sum of transactions from the sum of report profits.

The response format is a dictionary where each key is a currency code and
the corresponding value is the available amount.

Example response:
{
    "EUR": 100,
    "USD": 50
}
 * @summary Get Available Amount by Currency
 */
export const paymentAvailableAmountRetrieve = (signal?: AbortSignal) => {
  return paymentAvailableAmountRetrieveMutator<PaymentAvailableAmountRetrieve200>({
    url: `/api/v1/payment/available-amount/`,
    method: 'GET',
    signal,
  })
}

export const getPaymentAvailableAmountRetrieveQueryKey = () => {
  return [`/api/v1/payment/available-amount/`] as const
}

export const getPaymentAvailableAmountRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentAvailableAmountRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>> = ({
    signal,
  }) => paymentAvailableAmountRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentAvailableAmountRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>
>
export type PaymentAvailableAmountRetrieveQueryError = unknown

export function usePaymentAvailableAmountRetrieve<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
        TError,
        Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentAvailableAmountRetrieve<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
        TError,
        Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentAvailableAmountRetrieve<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Available Amount by Currency
 */

export function usePaymentAvailableAmountRetrieve<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentAvailableAmountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPaymentAvailableAmountRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentAvailableAmountRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>> = ({
    signal,
  }) => paymentAvailableAmountRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentAvailableAmountRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>
>
export type PaymentAvailableAmountRetrieveSuspenseQueryError = unknown

export function usePaymentAvailableAmountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentAvailableAmountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentAvailableAmountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Available Amount by Currency
 */

export function usePaymentAvailableAmountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof paymentAvailableAmountRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentAvailableAmountRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const paymentMethodCreateCreate = (
  paymentMethodCreate: PaymentMethodCreate,
  signal?: AbortSignal,
) => {
  return paymentMethodCreateCreateMutator<PaymentMethodCreate>({
    url: `/api/v1/payment/method-create/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: paymentMethodCreate,
    signal,
  })
}

export const getPaymentMethodCreateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentMethodCreateCreate>>,
    TError,
    { data: PaymentMethodCreate },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof paymentMethodCreateCreate>>,
  TError,
  { data: PaymentMethodCreate },
  TContext
> => {
  const mutationKey = ['paymentMethodCreateCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paymentMethodCreateCreate>>,
    { data: PaymentMethodCreate }
  > = (props) => {
    const { data } = props ?? {}

    return paymentMethodCreateCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PaymentMethodCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof paymentMethodCreateCreate>>
>
export type PaymentMethodCreateCreateMutationBody = PaymentMethodCreate
export type PaymentMethodCreateCreateMutationError = unknown

export const usePaymentMethodCreateCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentMethodCreateCreate>>,
    TError,
    { data: PaymentMethodCreate },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentMethodCreateCreate>>,
  TError,
  { data: PaymentMethodCreate },
  TContext
> => {
  const mutationOptions = getPaymentMethodCreateCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const paymentMethodListList = (signal?: AbortSignal) => {
  return paymentMethodListListMutator<PaymentMethod[]>({
    url: `/api/v1/payment/method-list/`,
    method: 'GET',
    signal,
  })
}

export const getPaymentMethodListListQueryKey = () => {
  return [`/api/v1/payment/method-list/`] as const
}

export const getPaymentMethodListListQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentMethodListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentMethodListList>>> = ({ signal }) =>
    paymentMethodListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentMethodListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentMethodListListQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentMethodListList>>
>
export type PaymentMethodListListQueryError = unknown

export function usePaymentMethodListList<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentMethodListList>>,
        TError,
        Awaited<ReturnType<typeof paymentMethodListList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentMethodListList<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentMethodListList>>,
        TError,
        Awaited<ReturnType<typeof paymentMethodListList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentMethodListList<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentMethodListList<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentMethodListListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPaymentMethodListListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentMethodListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentMethodListList>>> = ({ signal }) =>
    paymentMethodListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof paymentMethodListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentMethodListListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentMethodListList>>
>
export type PaymentMethodListListSuspenseQueryError = unknown

export function usePaymentMethodListListSuspense<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentMethodListListSuspense<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentMethodListListSuspense<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentMethodListListSuspense<
  TData = Awaited<ReturnType<typeof paymentMethodListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentMethodListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentMethodListListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * API view to list the last 10 redemption transactions for a logged-in user.
This provides a quick look at recent points expenditures.
 */
export const paymentRecentRedemptionsList = (signal?: AbortSignal) => {
  return paymentRecentRedemptionsListMutator<RedemptionHistory[]>({
    url: `/api/v1/payment/recent-redemptions/`,
    method: 'GET',
    signal,
  })
}

export const getPaymentRecentRedemptionsListQueryKey = () => {
  return [`/api/v1/payment/recent-redemptions/`] as const
}

export const getPaymentRecentRedemptionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentRecentRedemptionsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>> = ({
    signal,
  }) => paymentRecentRedemptionsList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentRecentRedemptionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentRecentRedemptionsList>>
>
export type PaymentRecentRedemptionsListQueryError = unknown

export function usePaymentRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
        TError,
        Awaited<ReturnType<typeof paymentRecentRedemptionsList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
        TError,
        Awaited<ReturnType<typeof paymentRecentRedemptionsList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentRecentRedemptionsListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPaymentRecentRedemptionsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentRecentRedemptionsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>> = ({
    signal,
  }) => paymentRecentRedemptionsList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentRecentRedemptionsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentRecentRedemptionsList>>
>
export type PaymentRecentRedemptionsListSuspenseQueryError = unknown

export function usePaymentRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof paymentRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentRecentRedemptionsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentRecentRedemptionsListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const paymentTransactionCreateCreate = (
  transactionCreate: NonReadonly<TransactionCreate>,
  signal?: AbortSignal,
) => {
  return paymentTransactionCreateCreateMutator<TransactionCreate>({
    url: `/api/v1/payment/transaction-create/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transactionCreate,
    signal,
  })
}

export const getPaymentTransactionCreateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentTransactionCreateCreate>>,
    TError,
    { data: NonReadonly<TransactionCreate> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof paymentTransactionCreateCreate>>,
  TError,
  { data: NonReadonly<TransactionCreate> },
  TContext
> => {
  const mutationKey = ['paymentTransactionCreateCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paymentTransactionCreateCreate>>,
    { data: NonReadonly<TransactionCreate> }
  > = (props) => {
    const { data } = props ?? {}

    return paymentTransactionCreateCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PaymentTransactionCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof paymentTransactionCreateCreate>>
>
export type PaymentTransactionCreateCreateMutationBody = NonReadonly<TransactionCreate>
export type PaymentTransactionCreateCreateMutationError = unknown

export const usePaymentTransactionCreateCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentTransactionCreateCreate>>,
    TError,
    { data: NonReadonly<TransactionCreate> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentTransactionCreateCreate>>,
  TError,
  { data: NonReadonly<TransactionCreate> },
  TContext
> => {
  const mutationOptions = getPaymentTransactionCreateCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * API view to provide a list of all financial transactions
for the authenticated user.
 */
export const paymentTransactionHistoryList = (
  params?: PaymentTransactionHistoryListParams,
  signal?: AbortSignal,
) => {
  return paymentTransactionHistoryListMutator<PaginatedTransactionHistoryList>({
    url: `/api/v1/payment/transaction-history/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getPaymentTransactionHistoryListQueryKey = (
  params?: PaymentTransactionHistoryListParams,
) => {
  return [`/api/v1/payment/transaction-history/`, ...(params ? [params] : [])] as const
}

export const getPaymentTransactionHistoryListQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionHistoryList>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentTransactionHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentTransactionHistoryList>>> = ({
    signal,
  }) => paymentTransactionHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentTransactionHistoryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentTransactionHistoryList>>
>
export type PaymentTransactionHistoryListQueryError = unknown

export function usePaymentTransactionHistoryList<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params: undefined | PaymentTransactionHistoryListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionHistoryList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
          TError,
          Awaited<ReturnType<typeof paymentTransactionHistoryList>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionHistoryList<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionHistoryList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
          TError,
          Awaited<ReturnType<typeof paymentTransactionHistoryList>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionHistoryList<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentTransactionHistoryList<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentTransactionHistoryListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPaymentTransactionHistoryListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentTransactionHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentTransactionHistoryList>>> = ({
    signal,
  }) => paymentTransactionHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentTransactionHistoryListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentTransactionHistoryList>>
>
export type PaymentTransactionHistoryListSuspenseQueryError = unknown

export function usePaymentTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params: undefined | PaymentTransactionHistoryListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
  TError = unknown,
>(
  params?: PaymentTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof paymentTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentTransactionHistoryListSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const paymentTransactionListList = (signal?: AbortSignal) => {
  return paymentTransactionListListMutator<Transaction[]>({
    url: `/api/v1/payment/transaction-list/`,
    method: 'GET',
    signal,
  })
}

export const getPaymentTransactionListListQueryKey = () => {
  return [`/api/v1/payment/transaction-list/`] as const
}

export const getPaymentTransactionListListQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentTransactionListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentTransactionListList>>> = ({
    signal,
  }) => paymentTransactionListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentTransactionListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentTransactionListListQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentTransactionListList>>
>
export type PaymentTransactionListListQueryError = unknown

export function usePaymentTransactionListList<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentTransactionListList>>,
        TError,
        Awaited<ReturnType<typeof paymentTransactionListList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionListList<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof paymentTransactionListList>>,
        TError,
        Awaited<ReturnType<typeof paymentTransactionListList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionListList<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentTransactionListList<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentTransactionListListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPaymentTransactionListListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPaymentTransactionListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentTransactionListList>>> = ({
    signal,
  }) => paymentTransactionListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof paymentTransactionListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentTransactionListListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentTransactionListList>>
>
export type PaymentTransactionListListSuspenseQueryError = unknown

export function usePaymentTransactionListListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionListListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentTransactionListListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentTransactionListListSuspense<
  TData = Awaited<ReturnType<typeof paymentTransactionListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentTransactionListList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPaymentTransactionListListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
